//nameofFactory.ts

// helps to ensure typesafetiness for property names in typescript
export const nameofFactory =
  <T>() =>
  (name: keyof T): keyof T =>
    name;

// helps to ensure typesafetiness for property names in typescript

/*
Example usage
import nameofFactory from './nameofFactory';

const nameof = nameofFactory<Person>();


interface Person {
    firstName: string;
    lastName: string;
}

const personName = nameof<Person>("noName");    //error!
 */

/* V2 of this ^ */

/* example usage:

const p1: Property<Candidate> = "firstName"; // ok
const p2: Property<Candidate> = "systemOnboarding.isBlocked"; // also ok
const p3: Property<Candidate> = "nonExistingProperty"; // nope
 */
